import React from "react";
import S from "gui/Components/ScreenHeader/ScreenHeaderDivider.module.scss";

export class ScreenheaderDivider extends React.Component {
  render() {
    return <div className={S.root} />;
  }
}
